export const REQUEST_CONTENT = 'CONTENT/REQUEST_CONTENT'
export const REQUEST_CONTENT_SUCCESS = 'CONTENT/REQUEST_CONTENT_SUCCESS'
export const REQUEST_CONTENT_FAILURE = 'CONTENT/REQUEST_CONTENT_FAILURE'

export const MARK_READ = 'CONTENT/MARK_READ'
export const MARK_UNREAD = 'CONTENT/MARK_UNREAD'

export const SEND_EVENT = 'ANALYTICS/SEND_EVENT'
